function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { AppContext } from 'context';
import LinkTile from 'components/LinkTile';
import intlShape from 'shapes/intlShape';
import * as shapes from '../../shapes';
import messages from '../../messages';
var _React_PureComponent;
class ProfileBox extends (_React_PureComponent = React.PureComponent) {
    get countryName() {
        return this.props.identity.countryName;
    }
    get imageFile() {
        const { countryCode } = this.props.identity;
        return `${countryCode}.svg`;
    }
    get profileName() {
        const { scope } = this.props.identity;
        return this.props.intl.formatMessage(messages.scopes[scope]);
    }
    get headMessage() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                this.countryName,
                /*#__PURE__*/ _jsx("span", {
                    className: "text--secondary text--normal mx-3",
                    children: "|"
                }),
                this.profileName
            ]
        });
    }
    render() {
        const { identityProviderType } = this.props.identity;
        return /*#__PURE__*/ _jsx(LinkTile, {
            labelMessage: this.headMessage,
            image: /*#__PURE__*/ _jsx("img", {
                src: `/aid/assets/svg/flags/${this.imageFile}`,
                alt: identityProviderType
            }),
            hasBorder: true,
            hasImageBorder: true,
            isDisabled: this.props.isDisabled,
            onClick: this.props.onClick
        });
    }
}
_define_property(ProfileBox, "contextType", AppContext);
_define_property(ProfileBox, "propTypes", {
    // Explicit props
    identity: PropTypes.shape({
        countryCode: PropTypes.string.isRequired,
        countryName: PropTypes.string.isRequired,
        scope: shapes.scopeName.isRequired,
        identityProviderType: PropTypes.string.isRequired
    }),
    isDisabled: PropTypes.bool,
    // Explicit actions
    onClick: PropTypes.func,
    // Implicit props
    intl: intlShape.isRequired
});
export default injectIntl(ProfileBox);
